import React, { useState } from 'react';
import { Star } from '@phosphor-icons/react';
import { Modal, InputField } from './Shared';
import { RATING_TAGS } from './constants';

export default function RatingModal({ item, api, onClose }) {
  const [rating, setRating] = useState(4);
  const [tags, setTags] = useState([]);
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.post('/meals/ratings', {
        plan_id: item.plan_id || '',
        date: item.date,
        meal_type: item.meal_type,
        dish_name: item.dish_name,
        rating,
        tags,
        notes,
      });
      onClose();
    } catch (e) { console.error(e); }
    setSaving(false);
  };

  return (
    <Modal onClose={onClose}>
      <h3 className="text-lg font-bold mb-1">Rate Dish</h3>
      <p className="text-sm text-neutral-400 mb-4">{item.dish_name}</p>
      <div className="space-y-4">
        <div>
          <label className="text-xs font-semibold text-neutral-500 uppercase block mb-2">Rating</label>
          <div className="flex gap-2">
            {[1, 2, 3, 4, 5].map(s => (
              <button key={s} onClick={() => setRating(s)} data-testid={`rating-star-${s}`}
                className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${s <= rating ? 'bg-yellow-500/20 text-yellow-400' : 'bg-white/5 text-neutral-600'}`}>
                <Star size={20} weight={s <= rating ? 'fill' : 'regular'} />
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className="text-xs font-semibold text-neutral-500 uppercase block mb-2">Quick Tags</label>
          <div className="flex flex-wrap gap-2">
            {RATING_TAGS.map(t => (
              <button key={t.id} onClick={() => setTags(prev => prev.includes(t.id) ? prev.filter(x => x !== t.id) : [...prev, t.id])}
                className={`px-3 py-1.5 rounded-lg text-[11px] font-semibold transition-all ${tags.includes(t.id) ? 'bg-[#FF6B35]/15 text-[#FF6B35] ring-1 ring-[#FF6B35]/30' : 'bg-white/5 text-neutral-400'}`}>
                {t.label}
              </button>
            ))}
          </div>
        </div>
        <InputField label="Notes (optional)" value={notes} onChange={setNotes} placeholder="Any feedback..." />
        <button onClick={handleSave} disabled={saving} data-testid="save-rating-btn"
          className="w-full py-3 rounded-xl bg-[#FF6B35] text-white text-sm font-bold disabled:opacity-50">
          {saving ? 'Saving...' : 'Save Rating'}
        </button>
      </div>
    </Modal>
  );
}
